{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2024                                      }
{            Email : info@tmssoftware.com                            }
{            Web : https://www.tmssoftware.com                       }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSFNCChartTypeEditor;

{$I WEBLib.TMSFNCDefines.inc}

{$IFDEF FMXLIB}
{$WARNINGS OFF}
{$HINTS OFF}
{$IF COMPILERVERSION > 30}
{$DEFINE DELPHIBERLIN}
{$IFEND}
{$HINTS ON}
{$WARNINGS ON}
{$ENDIF}

{$IFDEF VCLLIB}
{$DEFINE VCLWEBLIB}
{$ENDIF}
{$IFDEF CMNLIB}
{$DEFINE CMNWEBLIB}
{$ENDIF}
{$IFDEF WEBLIB}
{$DEFINE CMNWEBLIB}
{$DEFINE VCLWEBLIB}
{$ENDIF}

interface

uses
  Classes, WEBLib.TMSFNCCustomComponent, WEBLib.TMSFNCCustomControl, WEBLib.Controls,
  WEBLib.TMSFNCTypes, WEBLib.StdCtrls, WEBLib.ExtCtrls, WEBLib.Forms, WEBLib.TMSFNCGraphics, WEBLib.TMSFNCGraphicsTypes,
  WEBLib.TMSFNCChart, WEBLib.TMSFNCEditorButton, WEBLib.TMSFNCEditorPanel, WEBLib.TMSFNCEditorListView, WEBLib.TMSFNCBitmapEditor
  {$IFDEF FMXLIB}
  ,FMX.Types, FMX.Memo, FMX.ListBox, FMX.ComboEdit, FMX.SpinBox, FMX.Colors, FMX.Text, FMX.Edit, FMX.Layouts
  {$ENDIF}
  {$IFDEF VCLLIB}
  , Vcl.Samples.Spin
  {$ENDIF}
  {$IFDEF LCLLIB}
  , Spin, ColorBox
  {$ENDIF}
  {$IFDEF VCLLIB}
  , Vcl.ComCtrls
  {$ENDIF}
  {$IFNDEF LCLLIB}
  {$IFNDEF WEBLIB}
  ,UITypes
  {$ENDIF}
  ,Types
  {$ENDIF}
  ;

const
  MAJ_VER = 1; // Major version nr.
  MIN_VER = 0; // Minor version nr.
  REL_VER = 0; // Release nr.
  BLD_VER = 0; // Build nr.

  // version history
  // v1.0.0.0 : First Release

  {$IFDEF VCLLIB}
//  CHECKBOXSIZE = 13;
//  CHECKBOXOFFSET = 6;
  SMALLHEIGHTSPAC = 5;
  MIDHEIGHTSPAC = 10;
//  BIGHEIGHTSPAC = 15;
  {$ENDIF}
  {$IFDEF LCLLIB}
//  CHECKBOXSIZE = 13;
//  CHECKBOXOFFSET = 6;
  SMALLHEIGHTSPAC = 10;
  MIDHEIGHTSPAC = 15;
//  BIGHEIGHTSPAC = 20;
  {$ENDIF}
  {$IFDEF WEBLIB}
//  CHECKBOXSIZE = 17;
//  CHECKBOXOFFSET = 6;
  SMALLHEIGHTSPAC = 15;
  MIDHEIGHTSPAC = 15;
//  BIGHEIGHTSPAC = 20;
  {$ENDIF}
  {$IFDEF FMXLIB}
//  CHECKBOXSIZE = 15;
  SMALLHEIGHTSPAC = 10;
  MIDHEIGHTSPAC = 15;
//  BIGHEIGHTSPAC = 20;
  {$ENDIF}
//  BIGDIV = 30;
  SMALLLBLSPACE = 10;
  MIDLBLSPACE = 20;
//  BIGLBLSPACE = 30;
//  SMALLHORSPACE = 60;
//  MIDHORSPACE = 70;
//  BIGHORSPACE = 80;
//  SERIESLARGECONTROLWIDTH = 100;
//  LARGECONTROLWIDTH = 100;
//  SMALLCONTROLWIDTH = 45;
  VALUE_MBYES = 6;
  SELECTORSIZE = 80;

resourcestring
  sTMSFNCChartTypeEditorOK = 'OK';
  sTMSFNCChartTypeEditorCancel = 'Cancel';
  sTMSFNCChartTypeEditorLineTypes = 'Line Types';
  sTMSFNCChartTypeEditorAreaTypes = 'Area Types';
  sTMSFNCChartTypeEditorBarTypes = 'Bar Types';
  sTMSFNCChartTypeEditorMultiPointTypes = 'Multi-Point Types';
  sTMSFNCChartTypeEditorOtherTypes = 'Other Types';
  sTMSFNCChartTypeEditorSaveChartMessage = 'Are you sure you want to save the changes made?';
  sTMSFNCChartTypeEditorCancelChartMessage = 'Are you sure you don''t want to save the changes made?';
type
  TTMSFNCChartTypeEditor = class;

  TTMSFNCChartEditorSelector = class(TTMSFNCChartSelector)
  public
    constructor Create(AOwner: TComponent); override;
  end;

  {$IFDEF FMXLIB}
  TTMSFNCChartTypeEditorParent = TFmxObject;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  TTMSFNCChartTypeEditorParent = TWinControl;
  {$ENDIF}

  {$IFNDEF LCLLIB}
  [ComponentPlatformsAttribute(TMSPlatformsDesktop)]
  {$ENDIF}
  TTMSFNCChartTypeEditor = class(TTMSFNCCustomComponent)
  private
    FBitmapEditor: TTMSFNCBitmapEditor;
    {$IFNDEF FMXLIB}
    FVertScrlBox: TScrollBox;
    {$ENDIF}
    {$IFDEF FMXLIB}
    FVertScrlBox: TVertScrollBox;
    {$ENDIF}
    FGeneralPanel:TTMSFNCEditorPanel;

    FChartSelectorLine, FChartSelectorDigitalLine, FChartSelectorArea, FChartSelectorStackedArea, FChartSelectorStackedPercArea, FChartSelectorBar: TTMSFNCChartEditorSelector;
    FChartSelectorStackedBar, FChartSelectorPercBar, FChartSelectorMarker, FChartSelectorXYLine, FChartSelectorXYMarker, FChartSelectorPie: TTMSFNCChartEditorSelector;
    FChartSelectorVarRadiusPie, FChartSelectorSizedPie, FChartSelectorSpider, FChartSelectorBand, FChartSelectorOHLC, FChartSelectorCandleStick, FChartSelectorBoxPlot: TTMSFNCChartEditorSelector;

    frm: TTMSFNCCustomDesignerForm;
    FPanel: TTMSFNCEditorPanel;
    FChart: TTMSFNCChart;
    FCopyChart: TTMSFNCChart;
    FButtonOk, FButtonCancel: TTMSFNCEditorButton;
    FModified: Boolean;
    procedure SetChart(const Value: TTMSFNCChart);
    function CancelChartMessage: Boolean;
    function SaveChartMessage: Boolean;
  protected
    function GetInstance: NativeUInt; override;
    procedure RegisterRuntimeClasses; override;
    procedure Notification(AComponent: TComponent; AOperation: TOperation); override;
    procedure BuildEditor(AParent: TTMSFNCChartTypeEditorParent); virtual;
    procedure Initialize; virtual;
    procedure SetAppearance; virtual;
    {$IFNDEF FMXLIB}
    procedure DoFormKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
    {$ENDIF}
    {$IFDEF FMXLIB}
    procedure DoFormKeyDown(Sender: TObject; var Key: Word; var KeyChar: Char; Shift: TShiftState);
    {$ENDIF}
    procedure DoButtonOKClick(Sender: TObject); virtual;
    procedure DoButtonCancelClick(Sender: TObject); virtual;
    procedure DoChartSelectorClick(Sender: TObject); virtual;
    procedure CreateBottomPanel(AParent: TTMSFNCChartTypeEditorParent);
    {$IFDEF WEBLIB}
    procedure ApplyCSS(ACSS: string); virtual;
    {$ENDIF}
    function GetDocURL: string; override;
    function GetTipsURL: string; override;
  public
    constructor Create(AOwner: TComponent); override;
    destructor Destroy; override;
    {$IFDEF WEBLIB}
    procedure Execute(AProc: TModalResultProc = nil);
    {$ELSE}
    function Execute: TModalResult;
    {$ENDIF}
    procedure Assign(Source: TPersistent); override;
  published
    property Chart: TTMSFNCChart read FChart write SetChart;
  end;

  TTMSFNCChartTypeEditorForm = class(TTMSFNCCustomDesignerForm)
  {$IFDEF WEBLIB}
  private
    FChartEditor: TTMSFNCChartTypeEditor;
  protected
    procedure Loaded; override;
    procedure LoadDFMValues; override;
  public
    constructor CreateDialogNew(AChartEditor: TTMSFNCChartTypeEditor; ACaption: string); reintroduce; virtual;
  {$ENDIF}
  end;

  TTMSFNCChartTypeEditorDialog = class(TTMSFNCChartTypeEditor);

implementation

uses
  WEBLib.TMSFNCUtils, WEBLib.Graphics, SysUtils, WEBLib.TMSFNCEditorsTools
  {$IFDEF FMXLIB}
  ,WEBLib.Dialogs
  {$ENDIF}
  {$IFDEF VCLLIB}
  ,WEBLib.Dialogs, VCL.Themes
  {$ENDIF}
  {$IFDEF WEBLIB}
  ,WEBLib.Dialogs
  {$ENDIF}
  {$IFDEF LCLLIB}
  ,Dialogs
  {$ENDIF}
  {$IFDEF WEBLIB}
  ,WEBLib.WebTools
  {$ENDIF}
  {$IFNDEF FMXMOBILE}
  {$IFDEF DELPHIBERLIN}
  ,FMX.DialogService.Sync
  {$ENDIF}
  {$ENDIF}
  ;
//{$R TMSFNCChartTypeEditor.res}
type
  TTMSFNCChartOpen = class(TTMSFNCChart);

{ TTMSFNCChartTypeEditor }

function TranslateTextEx(AText: String): String;
begin
  {$IFDEF FMXLIB}
  Result := TranslateText(AText);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  Result := AText;
  {$ENDIF}
end;

procedure TTMSFNCChartTypeEditor.Notification(AComponent: TComponent;
  AOperation: TOperation);
begin
  inherited;
  if (AOperation = opRemove) and (AComponent = FChart) then
    FChart := nil;
end;

procedure TTMSFNCChartTypeEditor.RegisterRuntimeClasses;
begin
  inherited;
  RegisterClass(TTMSFNCChartTypeEditor);
end;

procedure TTMSFNCChartTypeEditor.Assign(Source: TPersistent);
begin
  if (Source is TTMSFNCChartTypeEditor) then
    FChart := (Source as TTMSFNCChartTypeEditor).Chart;
end;

procedure TTMSFNCChartTypeEditor.BuildEditor(AParent: TTMSFNCChartTypeEditorParent);
var
  lbl1: TLabel;
begin
  if Assigned(AParent) then
  begin
    {$IFDEF FMXLIB}
    FVertScrlBox := TVertScrollBox.Create(AParent);
    FVertScrlBox.Align := TAlignLayout.Client;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FVertScrlBox := TScrollBox.Create(AParent);
    FVertScrlBox.Align := alClient;
    FVertScrlBox.Top := 0;
    {$IFDEF LCLLIB}
    FVertScrlBox.HorzScrollBar.Visible:= False;
    {$ENDIF}
    {$ENDIF}
    FVertScrlBox.Parent := AParent;
    {$IFDEF CMNWEBLIB}
    FVertScrlBox.BorderStyle := bsNone;
    if IsLightTheme then
      FVertScrlBox.Color := EDITORSUBBACKCOLORLIGHT
    else
      FVertScrlBox.Color := EDITORSUBBACKCOLORDARK;
    {$ENDIF}


    //                  General Panel
    //**************************************************

    FGeneralPanel := TTMSFNCEditorPanel.Create(FVertScrlBox);
    {$IFDEF FMXLIB}
    FGeneralPanel.Align := TAlignLayout.Top;
    FGeneralPanel.PanelPosition := eppBottom;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FGeneralPanel.PanelPosition := eppCenter;
    FGeneralPanel.Align := alTop;
    FGeneralPanel.Top := 0;
    {$ENDIF}
    FGeneralPanel.Parent := FVertScrlBox;

    lbl1 := TLabel.Create(FGeneralPanel);
    lbl1.Parent := FGeneralPanel;
    lbl1.AutoSize := True;
    {$IFDEF FMXLIB}
    lbl1.Position.X := SMALLLBLSPACE;
    lbl1.Position.Y := MIDHEIGHTSPAC;
    lbl1.Text := TranslateTextEx(sTMSFNCChartTypeEditorLineTypes);
    lbl1.StyledSettings := lbl1.StyledSettings - [TStyledSetting.Size, TStyledSetting.Style];
    lbl1.Font.Size := 18;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl1.Left := SMALLLBLSPACE;
    lbl1.Top := MIDHEIGHTSPAC;
    lbl1.Caption := TranslateTextEx(sTMSFNCChartTypeEditorLineTypes);
    lbl1.Font.Size := 15;
    {$ENDIF}
    lbl1.Font.Style := [TFontStyle.fsBold];
    SetEditorLabelAppearance(lbl1);

    FChartSelectorLine := TTMSFNCChartEditorSelector.Create(FGeneralPanel);
    FChartSelectorLine.Parent := FGeneralPanel;
    FChartSelectorLine.ChartType := ctLine;
    {$IFDEF FMXLIB}
    FChartSelectorLine.Position.X := lbl1.Position.X + MIDLBLSPACE;
    FChartSelectorLine.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FChartSelectorLine.Left := lbl1.Left + MIDLBLSPACE;
    FChartSelectorLine.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
    {$ENDIF}
    {$IFDEF FMXLIB}
    FChartSelectorLine.Font.Size := 12;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FChartSelectorLine.Font.Size := 8;
    {$ENDIF}
    FChartSelectorLine.OnClick := @DoChartSelectorClick;

    FChartSelectorDigitalLine := TTMSFNCChartEditorSelector.Create(FGeneralPanel);
    FChartSelectorDigitalLine.Parent := FGeneralPanel;
    FChartSelectorDigitalLine.ChartType := ctXYLine;
    {$IFDEF FMXLIB}
    FChartSelectorDigitalLine.Position.X := FChartSelectorLine.Position.X + FChartSelectorLine.Width + SMALLLBLSPACE;
    FChartSelectorDigitalLine.Position.Y := FChartSelectorLine.Position.Y;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FChartSelectorDigitalLine.Left := FChartSelectorLine.Left + FChartSelectorLine.Width + SMALLLBLSPACE;
    FChartSelectorDigitalLine.Top := FChartSelectorLine.Top;
    {$ENDIF}
    FChartSelectorDigitalLine.Width := FChartSelectorLine.Width;
    FChartSelectorDigitalLine.Height := FChartSelectorLine.Height;
    FChartSelectorDigitalLine.OnClick := @DoChartSelectorClick;

    FChartSelectorXYLine := TTMSFNCChartEditorSelector.Create(FGeneralPanel);
    FChartSelectorXYLine.Parent := FGeneralPanel;
    FChartSelectorXYLine.ChartType := ctDigitalLine;
    {$IFDEF FMXLIB}
    FChartSelectorXYLine.Position.X := FChartSelectorDigitalLine.Position.X + FChartSelectorDigitalLine.Width + SMALLLBLSPACE;
    FChartSelectorXYLine.Position.Y := FChartSelectorDigitalLine.Position.Y;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FChartSelectorXYLine.Left := FChartSelectorDigitalLine.Left + FChartSelectorDigitalLine.Width + SMALLLBLSPACE;
    FChartSelectorXYLine.Top := FChartSelectorDigitalLine.Top;
    {$ENDIF}
    FChartSelectorXYLine.Width := FChartSelectorLine.Width;
    FChartSelectorXYLine.Height := FChartSelectorLine.Height;
    FChartSelectorXYLine.Tag := 1;
    FChartSelectorXYLine.OnClick := @DoChartSelectorClick;

    lbl1 := TLabel.Create(FGeneralPanel);
    lbl1.Parent := FGeneralPanel;
    lbl1.AutoSize := True;
    {$IFDEF FMXLIB}
    lbl1.Position.X := SMALLLBLSPACE;
    lbl1.Position.Y := FChartSelectorXYLine.Position.Y + FChartSelectorXYLine.Height + SMALLHEIGHTSPAC;
    lbl1.Text := TranslateTextEx(sTMSFNCChartTypeEditorAreaTypes);
    lbl1.StyledSettings := lbl1.StyledSettings - [TStyledSetting.Size, TStyledSetting.Style];
    lbl1.Font.Size := 18;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl1.Left := SMALLLBLSPACE;
    lbl1.Top := FChartSelectorXYLine.Top + FChartSelectorXYLine.Height + SMALLHEIGHTSPAC;
    lbl1.Caption := TranslateTextEx(sTMSFNCChartTypeEditorAreaTypes);
    lbl1.Font.Size := 15;
    {$ENDIF}
    lbl1.Font.Style := [TFontStyle.fsBold];
    SetEditorLabelAppearance(lbl1);

    FChartSelectorArea := TTMSFNCChartEditorSelector.Create(FGeneralPanel);
    FChartSelectorArea.Parent := FGeneralPanel;
    FChartSelectorArea.ChartType := ctArea;
    {$IFDEF FMXLIB}
    FChartSelectorArea.Position.X := lbl1.Position.X + MIDLBLSPACE;
    FChartSelectorArea.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FChartSelectorArea.Left := lbl1.Left + MIDLBLSPACE;
    FChartSelectorArea.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
    {$ENDIF}
    FChartSelectorArea.Width := FChartSelectorLine.Width;
    FChartSelectorArea.Height := FChartSelectorLine.Height;
    FChartSelectorArea.OnClick := @DoChartSelectorClick;

    FChartSelectorStackedArea := TTMSFNCChartEditorSelector.Create(FGeneralPanel);
    FChartSelectorStackedArea.Parent := FGeneralPanel;
    FChartSelectorStackedArea.ChartType := ctStackedArea;
    {$IFDEF FMXLIB}
    FChartSelectorStackedArea.Position.X := FChartSelectorArea.Position.X + FChartSelectorArea.Width + SMALLLBLSPACE;
    FChartSelectorStackedArea.Position.Y := FChartSelectorArea.Position.Y;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FChartSelectorStackedArea.Left := FChartSelectorArea.Left + FChartSelectorArea.Width + SMALLLBLSPACE;
    FChartSelectorStackedArea.Top := FChartSelectorArea.Top;
    {$ENDIF}
    FChartSelectorStackedArea.Width := FChartSelectorLine.Width;
    FChartSelectorStackedArea.Height := FChartSelectorLine.Height;
    FChartSelectorStackedArea.OnClick := @DoChartSelectorClick;

    FChartSelectorStackedPercArea := TTMSFNCChartEditorSelector.Create(FGeneralPanel);
    FChartSelectorStackedPercArea.Parent := FGeneralPanel;
    FChartSelectorStackedPercArea.ChartType := ctStackedPercentageArea;
    {$IFDEF FMXLIB}
    FChartSelectorStackedPercArea.Position.X := FChartSelectorStackedArea.Position.X + FChartSelectorStackedArea.Width + SMALLLBLSPACE;
    FChartSelectorStackedPercArea.Position.Y := FChartSelectorArea.Position.Y;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FChartSelectorStackedPercArea.Left := FChartSelectorStackedArea.Left + FChartSelectorStackedArea.Width + SMALLLBLSPACE;
    FChartSelectorStackedPercArea.Top := FChartSelectorArea.Top;
    {$ENDIF}
    FChartSelectorStackedPercArea.Width := FChartSelectorLine.Width;
    FChartSelectorStackedPercArea.Height := FChartSelectorLine.Height;
    FChartSelectorStackedPercArea.OnClick := @DoChartSelectorClick;

    FChartSelectorBand := TTMSFNCChartEditorSelector.Create(FGeneralPanel);
    FChartSelectorBand.Parent := FGeneralPanel;
    FChartSelectorBand.ChartType := ctBand;
    {$IFDEF FMXLIB}
    FChartSelectorBand.Position.X := FChartSelectorStackedPercArea.Position.X + FChartSelectorStackedPercArea.Width + SMALLLBLSPACE;
    FChartSelectorBand.Position.Y := FChartSelectorArea.Position.Y;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FChartSelectorBand.Left := FChartSelectorStackedPercArea.Left + FChartSelectorStackedPercArea.Width + SMALLLBLSPACE;
    FChartSelectorBand.Top := FChartSelectorArea.Top;
    {$ENDIF}
    FChartSelectorBand.Width := FChartSelectorLine.Width;
    FChartSelectorBand.Height := FChartSelectorLine.Height;
    FChartSelectorBand.OnClick := @DoChartSelectorClick;

    lbl1 := TLabel.Create(FGeneralPanel);
    lbl1.Parent := FGeneralPanel;
    lbl1.AutoSize := True;
    {$IFDEF FMXLIB}
    lbl1.Position.X := SMALLLBLSPACE;
    lbl1.Position.Y := FChartSelectorBand.Position.Y + FChartSelectorBand.Height + SMALLHEIGHTSPAC;
    lbl1.Text := TranslateTextEx(sTMSFNCChartTypeEditorBarTypes);
    lbl1.StyledSettings := lbl1.StyledSettings - [TStyledSetting.Size, TStyledSetting.Style];
    lbl1.Font.Size := 18;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl1.Left := SMALLLBLSPACE;
    lbl1.Top := FChartSelectorBand.Top + FChartSelectorBand.Height + SMALLHEIGHTSPAC;
    lbl1.Caption := TranslateTextEx(sTMSFNCChartTypeEditorBarTypes);
    lbl1.Font.Size := 15;
    {$ENDIF}
    lbl1.Font.Style := [TFontStyle.fsBold];
    SetEditorLabelAppearance(lbl1);

    FChartSelectorBar := TTMSFNCChartEditorSelector.Create(FGeneralPanel);
    FChartSelectorBar.Parent := FGeneralPanel;
    FChartSelectorBar.ChartType := ctBar;
    {$IFDEF FMXLIB}
    FChartSelectorBar.Position.X := lbl1.Position.X + MIDLBLSPACE;
    FChartSelectorBar.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FChartSelectorBar.Left := lbl1.Left + MIDLBLSPACE;
    FChartSelectorBar.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
    {$ENDIF}
    FChartSelectorBar.Width := FChartSelectorLine.Width;
    FChartSelectorBar.Height := FChartSelectorLine.Height;
    FChartSelectorBar.OnClick := @DoChartSelectorClick;

    FChartSelectorStackedBar := TTMSFNCChartEditorSelector.Create(FGeneralPanel);
    FChartSelectorStackedBar.Parent := FGeneralPanel;
    FChartSelectorStackedBar.ChartType := ctStackedBar;
    {$IFDEF FMXLIB}
    FChartSelectorStackedBar.Position.X := FChartSelectorBar.Position.X + FChartSelectorBar.Width + SMALLLBLSPACE;
    FChartSelectorStackedBar.Position.Y := FChartSelectorBar.Position.Y;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FChartSelectorStackedBar.Left := FChartSelectorBar.Left + FChartSelectorBar.Width + SMALLLBLSPACE;
    FChartSelectorStackedBar.Top := FChartSelectorBar.Top;
    {$ENDIF}
    FChartSelectorStackedBar.Width := FChartSelectorLine.Width;
    FChartSelectorStackedBar.Height := FChartSelectorLine.Height;
    FChartSelectorStackedBar.OnClick := @DoChartSelectorClick;

    FChartSelectorPercBar := TTMSFNCChartEditorSelector.Create(FGeneralPanel);
    FChartSelectorPercBar.Parent := FGeneralPanel;
    FChartSelectorPercBar.ChartType := ctStackedPercentageBar;
    {$IFDEF FMXLIB}
    FChartSelectorPercBar.Position.X := FChartSelectorStackedBar.Position.X + FChartSelectorStackedBar.Width + SMALLLBLSPACE;
    FChartSelectorPercBar.Position.Y := FChartSelectorStackedBar.Position.Y;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FChartSelectorPercBar.Left := FChartSelectorStackedBar.Left + FChartSelectorStackedBar.Width + SMALLLBLSPACE;
    FChartSelectorPercBar.Top := FChartSelectorStackedBar.Top;
    {$ENDIF}
    FChartSelectorPercBar.Width := FChartSelectorLine.Width;
    FChartSelectorPercBar.Height := FChartSelectorLine.Height;
    FChartSelectorPercBar.OnClick := @DoChartSelectorClick;

    lbl1 := TLabel.Create(FGeneralPanel);
    lbl1.Parent := FGeneralPanel;
    lbl1.AutoSize := True;
    {$IFDEF FMXLIB}
    lbl1.Position.X := SMALLLBLSPACE;
    lbl1.Position.Y := FChartSelectorPercBar.Position.Y + FChartSelectorPercBar.Height + SMALLHEIGHTSPAC;
    lbl1.Text := TranslateTextEx(sTMSFNCChartTypeEditorMultiPointTypes);
    lbl1.StyledSettings := lbl1.StyledSettings - [TStyledSetting.Size, TStyledSetting.Style];
    lbl1.Font.Size := 18;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl1.Left := SMALLLBLSPACE;
    lbl1.Top := FChartSelectorPercBar.Top + FChartSelectorPercBar.Height + SMALLHEIGHTSPAC;
    lbl1.Caption := TranslateTextEx(sTMSFNCChartTypeEditorMultiPointTypes);
    lbl1.Font.Size := 15;
    {$ENDIF}
    lbl1.Width := 300;
    lbl1.Font.Style := [TFontStyle.fsBold];
    SetEditorLabelAppearance(lbl1);

    FChartSelectorOHLC := TTMSFNCChartEditorSelector.Create(FGeneralPanel);
    FChartSelectorOHLC.Parent := FGeneralPanel;
    FChartSelectorOHLC.ChartType := ctOHLC;
    {$IFDEF FMXLIB}
    FChartSelectorOHLC.Position.X := lbl1.Position.X + MIDLBLSPACE;
    FChartSelectorOHLC.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FChartSelectorOHLC.Left := lbl1.Left + MIDLBLSPACE;
    FChartSelectorOHLC.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
    {$ENDIF}
    FChartSelectorOHLC.Width := FChartSelectorLine.Width;
    FChartSelectorOHLC.Height := FChartSelectorLine.Height;
    FChartSelectorOHLC.OnClick := @DoChartSelectorClick;

    FChartSelectorCandleStick := TTMSFNCChartEditorSelector.Create(FGeneralPanel);
    FChartSelectorCandleStick.Parent := FGeneralPanel;
    FChartSelectorCandleStick.ChartType := ctCandleStick;
    {$IFDEF FMXLIB}
    FChartSelectorCandleStick.Position.X := FChartSelectorOHLC.Position.X + FChartSelectorOHLC.Width + SMALLLBLSPACE;
    FChartSelectorCandleStick.Position.Y := FChartSelectorOHLC.Position.Y;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FChartSelectorCandleStick.Left := FChartSelectorOHLC.Left + FChartSelectorOHLC.Width + SMALLLBLSPACE;
    FChartSelectorCandleStick.Top := FChartSelectorOHLC.Top;
    {$ENDIF}
    FChartSelectorCandleStick.Width := FChartSelectorLine.Width;
    FChartSelectorCandleStick.Height := FChartSelectorLine.Height;
    FChartSelectorCandleStick.OnClick := @DoChartSelectorClick;

    FChartSelectorBoxPlot := TTMSFNCChartEditorSelector.Create(FGeneralPanel);
    FChartSelectorBoxPlot.Parent := FGeneralPanel;
    FChartSelectorBoxPlot.ChartType := ctBoxPlot;
    {$IFDEF FMXLIB}
    FChartSelectorBoxPlot.Position.X := FChartSelectorCandleStick.Position.X + FChartSelectorCandleStick.Width + SMALLLBLSPACE;
    FChartSelectorBoxPlot.Position.Y := FChartSelectorCandleStick.Position.Y;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FChartSelectorBoxPlot.Left := FChartSelectorCandleStick.Left + FChartSelectorCandleStick.Width + SMALLLBLSPACE;
    FChartSelectorBoxPlot.Top := FChartSelectorCandleStick.Top;
    {$ENDIF}
    FChartSelectorBoxPlot.Width := FChartSelectorLine.Width;
    FChartSelectorBoxPlot.Height := FChartSelectorLine.Height;
    FChartSelectorBoxPlot.OnClick := @DoChartSelectorClick;

    lbl1 := TLabel.Create(FGeneralPanel);
    lbl1.Parent := FGeneralPanel;
    lbl1.AutoSize := True;
    {$IFDEF FMXLIB}
    lbl1.Position.X := SMALLLBLSPACE;
    lbl1.Position.Y := FChartSelectorBoxPlot.Position.Y + FChartSelectorBoxPlot.Height + SMALLHEIGHTSPAC;
    lbl1.Text := TranslateTextEx(sTMSFNCChartTypeEditorOtherTypes);
    lbl1.StyledSettings := lbl1.StyledSettings - [TStyledSetting.Size, TStyledSetting.Style];
    lbl1.Font.Size := 18;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl1.Left := SMALLLBLSPACE;
    lbl1.Top := FChartSelectorBoxPlot.Top + FChartSelectorBoxPlot.Height + SMALLHEIGHTSPAC;
    lbl1.Caption := TranslateTextEx(sTMSFNCChartTypeEditorOtherTypes);
    lbl1.Font.Size := 15;
    {$ENDIF}
    lbl1.Width := 300;
    lbl1.Font.Style := [TFontStyle.fsBold];
    SetEditorLabelAppearance(lbl1);

    FChartSelectorMarker := TTMSFNCChartEditorSelector.Create(FGeneralPanel);
    FChartSelectorMarker.Parent := FGeneralPanel;
    FChartSelectorMarker.ChartType := ctMarker;
    {$IFDEF FMXLIB}
    FChartSelectorMarker.Position.X := lbl1.Position.X + MIDLBLSPACE;
    FChartSelectorMarker.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FChartSelectorMarker.Left := lbl1.Left + MIDLBLSPACE;
    FChartSelectorMarker.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
    {$ENDIF}
    FChartSelectorMarker.Width := FChartSelectorLine.Width;
    FChartSelectorMarker.Height := FChartSelectorLine.Height;
    FChartSelectorMarker.OnClick := @DoChartSelectorClick;

    FChartSelectorXYMarker := TTMSFNCChartEditorSelector.Create(FGeneralPanel);
    FChartSelectorXYMarker.Parent := FGeneralPanel;
    FChartSelectorXYMarker.ChartType := ctXYMarker;
    {$IFDEF FMXLIB}
    FChartSelectorXYMarker.Position.X := FChartSelectorMarker.Position.X + FChartSelectorMarker.Width + SMALLLBLSPACE;
    FChartSelectorXYMarker.Position.Y := FChartSelectorMarker.Position.Y;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FChartSelectorXYMarker.Left := FChartSelectorMarker.Left + FChartSelectorMarker.Width + SMALLLBLSPACE;
    FChartSelectorXYMarker.Top := FChartSelectorMarker.Top;
    {$ENDIF}
    FChartSelectorXYMarker.Width := FChartSelectorLine.Width;
    FChartSelectorXYMarker.Height := FChartSelectorLine.Height;
    FChartSelectorXYMarker.OnClick := @DoChartSelectorClick;

    FChartSelectorPie := TTMSFNCChartEditorSelector.Create(FGeneralPanel);
    FChartSelectorPie.Parent := FGeneralPanel;
    FChartSelectorPie.ChartType := ctPie;
    {$IFDEF FMXLIB}
    FChartSelectorPie.Position.X := FChartSelectorXYMarker.Position.X + FChartSelectorXYMarker.Width + SMALLLBLSPACE;
    FChartSelectorPie.Position.Y := FChartSelectorXYMarker.Position.Y;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FChartSelectorPie.Left := FChartSelectorXYMarker.Left + FChartSelectorXYMarker.Width + SMALLLBLSPACE;
    FChartSelectorPie.Top := FChartSelectorXYMarker.Top;
    {$ENDIF}
    FChartSelectorPie.Width := FChartSelectorLine.Width;
    FChartSelectorPie.Height := FChartSelectorLine.Height;
    FChartSelectorPie.OnClick := @DoChartSelectorClick;

    FChartSelectorSizedPie := TTMSFNCChartEditorSelector.Create(FGeneralPanel);
    FChartSelectorSizedPie.Parent := FGeneralPanel;
    FChartSelectorSizedPie.ChartType := ctSizedPie;
    {$IFDEF FMXLIB}
    FChartSelectorSizedPie.Position.X := FChartSelectorPie.Position.X + FChartSelectorPie.Width + SMALLLBLSPACE;
    FChartSelectorSizedPie.Position.Y := FChartSelectorPie.Position.Y;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FChartSelectorSizedPie.Left := FChartSelectorPie.Left + FChartSelectorPie.Width + SMALLLBLSPACE;
    FChartSelectorSizedPie.Top := FChartSelectorPie.Top;
    {$ENDIF}
    FChartSelectorSizedPie.Width := FChartSelectorLine.Width;
    FChartSelectorSizedPie.Height := FChartSelectorLine.Height;
    FChartSelectorSizedPie.OnClick := @DoChartSelectorClick;

    FChartSelectorVarRadiusPie := TTMSFNCChartEditorSelector.Create(FGeneralPanel);
    FChartSelectorVarRadiusPie.Parent := FGeneralPanel;
    FChartSelectorVarRadiusPie.ChartType := ctVariableRadiusPie;
    {$IFDEF FMXLIB}
    FChartSelectorVarRadiusPie.Position.X := FChartSelectorSizedPie.Position.X + FChartSelectorSizedPie.Width + SMALLLBLSPACE;
    FChartSelectorVarRadiusPie.Position.Y := FChartSelectorSizedPie.Position.Y;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FChartSelectorVarRadiusPie.Left := FChartSelectorSizedPie.Left + FChartSelectorSizedPie.Width + SMALLLBLSPACE;
    FChartSelectorVarRadiusPie.Top := FChartSelectorSizedPie.Top;
    {$ENDIF}
    FChartSelectorVarRadiusPie.Width := FChartSelectorLine.Width;
    FChartSelectorVarRadiusPie.Height := FChartSelectorLine.Height;
    FChartSelectorVarRadiusPie.OnClick := @DoChartSelectorClick;

    FChartSelectorSpider := TTMSFNCChartEditorSelector.Create(FGeneralPanel);
    FChartSelectorSpider.Parent := FGeneralPanel;
    FChartSelectorSpider.ChartType := ctSpider;
    {$IFDEF FMXLIB}
    FChartSelectorSpider.Position.X := FChartSelectorVarRadiusPie.Position.X + FChartSelectorVarRadiusPie.Width + SMALLLBLSPACE;
    FChartSelectorSpider.Position.Y := FChartSelectorVarRadiusPie.Position.Y;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FChartSelectorSpider.Left := FChartSelectorVarRadiusPie.Left + FChartSelectorVarRadiusPie.Width + SMALLLBLSPACE;
    FChartSelectorSpider.Top := FChartSelectorVarRadiusPie.Top;
    {$ENDIF}
    FChartSelectorSpider.Width := FChartSelectorLine.Width;
    FChartSelectorSpider.Height := FChartSelectorLine.Height;
    FChartSelectorSpider.OnClick := @DoChartSelectorClick;

    {$IFDEF FMXLIB}
    FGeneralPanel.Height := FChartSelectorSpider.Position.Y + FChartSelectorSpider.Height + SMALLHEIGHTSPAC;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FGeneralPanel.Height := FChartSelectorSpider.Top + FChartSelectorSpider.Height + SMALLHEIGHTSPAC;
    {$ENDIF}



    //                     Bottom Panel
    //-------------------------------------------------------

    CreateBottomPanel(AParent);

    Initialize;
    SetAppearance;
  end;
end;

procedure TTMSFNCChartTypeEditor.DoButtonOKClick(Sender: TObject);
begin
  if Assigned(frm) then
  begin
    {$IFNDEF WEBLIB}
    if FModified then
    begin
      if SaveChartMessage then
    {$ENDIF}
      frm.ModalResult := mrOk;
    {$IFNDEF WEBLIB}
    end
    else
      frm.ModalResult := mrOk;
    {$ENDIF}
  end;
end;

procedure TTMSFNCChartTypeEditor.DoButtonCancelClick(Sender: TObject);
begin
  if Assigned(frm) then
  begin
    {$IFNDEF WEBLIB}
    if FModified then
    begin
      if CancelChartMessage then
    {$ENDIF}
      frm.ModalResult := mrCancel;
    {$IFNDEF WEBLIB}
    end
    else
      frm.ModalResult := mrCancel;
    {$ENDIF}
  end;
end;

{$IFDEF WEBLIB}
procedure TTMSFNCChartTypeEditor.ApplyCSS(ACSS: string);
begin
//  FButtonOK.ElementClassName := 'IDEButton IDEFont';
//  FButtonCancel.ElementClassName := 'IDEButton IDEFont';
//  FButtonOpen.ElementClassName := 'IDEButton IDEFont';
//  FButtonClear.ElementClassName := 'IDEButton IDEFont';
//
//  FTopPanel.ElementClassName := 'IDEBkg';
//  FPanel.ElementClassName := 'IDEBkg';
end;
{$ENDIF}

function TTMSFNCChartTypeEditor.CancelChartMessage: Boolean;
var
  res: Integer;
begin
  {$IFNDEF WEBLIB}
  Result := False;
  res := TTMSFNCUtils.Message(sTMSFNCChartTypeEditorCancelChartMessage, TMsgDlgType.mtConfirmation, [TMsgDlgBtn.mbYes, TMsgDlgBtn.mbNo], 0);
  if res = VALUE_MBYES then
  {$ENDIF}
    Result := True;
end;

constructor TTMSFNCChartTypeEditor.Create(AOwner: TComponent);
begin
  inherited;
  FBitmapEditor := TTMSFNCBitmapEditor.Create(Self);
end;

procedure TTMSFNCChartTypeEditor.CreateBottomPanel(AParent: TTMSFNCChartTypeEditorParent);
begin
  FPanel := TTMSFNCEditorPanel.Create(AParent);
  {$IFDEF FMXLIB}
  FPanel.Align := TAlignLayout.Bottom;
  FPanel.PanelPosition := eppBottom;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FPanel.PanelPosition := eppCenter;
  FPanel.Align := alBottom;
  {$ENDIF}
  FPanel.Parent := AParent;

  FPanel.Height := 37;

  FButtonCancel := TTMSFNCEditorButton.Create(FPanel);
//    FButtonCancel.ModalResult := mrCancel;
  FButtonCancel.Parent := FPanel;
  FButtonCancel.Text := TranslateTextEx(sTMSFNCChartTypeEditorCancel);
  {$IFDEF FMXLIB}
  FButtonCancel.Align := TAlignLayout.Right;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FButtonCancel.Align := alRight;
  FButtonCancel.Left := 99;
  {$IFDEF VCLWEBLIB}
  FButtonCancel.AlignWithMargins := True;
  {$ENDIF}
  {$ENDIF}
  {$IFDEF LCLLIB}
  FButtonCancel.BorderSpacing.Right := 5;
  FButtonCancel.BorderSpacing.Top := 5;
  FButtonCancel.BorderSpacing.Bottom := 5;
  FButtonCancel.BorderSpacing.Left := 5;
  {$ENDIF}
  {$IFNDEF LCLLIB}
  FButtonCancel.Margins.Right := 5;
  FButtonCancel.Margins.Top := 5;
  FButtonCancel.Margins.Bottom := 5;
  FButtonCancel.Margins.Left := 5;
  {$ENDIF}
  FButtonCancel.OnClick := @DoButtonCancelClick;

  FButtonOK := TTMSFNCEditorButton.Create(FPanel);
//    FButtonOK.ModalResult := mrOk;
  FButtonOK.Parent := FPanel;
  FButtonOK.Text := TranslateTextEx(sTMSFNCChartTypeEditorOK);
  {$IFDEF FMXLIB}
  FButtonOk.Align := TAlignLayout.Right;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FButtonOk.Align := alRight;
  FButtonOk.Left := 98;
  {$IFDEF VCLWEBLIB}
  FButtonOK.AlignWithMargins := True;
  {$ENDIF}
  {$ENDIF}
  {$IFNDEF LCLLIB}
  FButtonOK.Margins.Right := 0;
  FButtonOK.Margins.Top := 5;
  FButtonOK.Margins.Bottom := 5;
  FButtonOK.Margins.Left := 5;
  {$ENDIF}
  {$IFDEF LCLLIB}
  FButtonOK.BorderSpacing.Right := 0;
  FButtonOK.BorderSpacing.Top := 5;
  FButtonOK.BorderSpacing.Bottom := 5;
  FButtonOK.BorderSpacing.Left := 5;
  {$ENDIF}
  FButtonOK.OnClick := @DoButtonOKClick;
end;

destructor TTMSFNCChartTypeEditor.Destroy;
begin
  FBitmapEditor.Free;
  inherited;
end;

{$IFNDEF FMXLIB}
procedure TTMSFNCChartTypeEditor.DoFormKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
{$ENDIF}
{$IFDEF FMXLIB}
procedure TTMSFNCChartTypeEditor.DoFormKeyDown(Sender: TObject; var Key: Word; var KeyChar: Char; Shift: TShiftState);
{$ENDIF}
begin
  inherited;

  if Key = KEY_ESCAPE then
    DoButtonCancelClick(Self)
  else if Key = KEY_RETURN then
    DoButtonOKClick(Self);
end;

procedure TTMSFNCChartTypeEditor.DoChartSelectorClick(Sender: TObject);
var
  I: Integer;
begin
  FChartSelectorLine.Selected := False;
  FChartSelectorDigitalLine.Selected := False;
  FChartSelectorXYLine.Selected := False;
  FChartSelectorArea.Selected := False;
  FChartSelectorStackedArea.Selected := False;
  FChartSelectorStackedPercArea.Selected := False;
  FChartSelectorBand.Selected := False;
  FChartSelectorBar.Selected := False;
  FChartSelectorStackedBar.Selected := False;
  FChartSelectorPercBar.Selected := False;
  FChartSelectorOHLC.Selected := False;
  FChartSelectorCandleStick.Selected := False;
  FChartSelectorBoxPlot.Selected := False;
  FChartSelectorMarker.Selected := False;
  FChartSelectorXYMarker.Selected := False;
  FChartSelectorPie.Selected := False;
  FChartSelectorSizedPie.Selected := False;
  FChartSelectorVarRadiusPie.Selected := False;
  FChartSelectorSpider.Selected := False;

  TTMSFNCChartEditorSelector(Sender).Selected := True;

  if Assigned(FChart) then
  begin
    for I := 0 to FChart.Series.Count - 1 do
    begin
      FChart.Series[I].ChartType := TTMSFNCChartEditorSelector(Sender).ChartType;
    end;
  end;

  FModified := True;
end;

{$IFDEF WEBLIB}
procedure TTMSFNCChartTypeEditor.Execute(AProc: TModalResultProc = nil);
{$ELSE}
function TTMSFNCChartTypeEditor.Execute: TModalResult;
{$ENDIF}
begin
  if not Assigned(Chart) then
  begin
    raise Exception.Create('No chart was assigned to the editor!');
    Exit;
  end;

  {$IFDEF WEBLIB}
  frm := TTMSFNCChartTypeEditorForm.CreateDialogNew(Self, 'Chart Type Editor');
  {$ELSE}
  frm := TTMSFNCChartTypeEditorForm.CreateNew(Application);
  frm.Caption := 'Chart Type Editor';
  frm.BorderIcons := [TBorderIcon.biSystemMenu, TBorderIcon.biMinimize];
  {$ENDIF}

  FCopyChart := TTMSFNCChart.Create(frm);
  FCopyChart.Assign(Chart);

  frm.Width := 730;
  frm.Height := 700;

  {$IFDEF FMXLIB}
  frm.Position := TFormPosition.ScreenCenter;
  frm.Fill.Kind := TBrushKind.Solid;
  if IsLightTheme then
    frm.Fill.Color := EDITORSUBBACKCOLORLIGHT
  else
    frm.Fill.Color := EDITORSUBBACKCOLORDARK;
  {$ENDIF}
  {$IFDEF CMNLIB}
  frm.KeyPreview := True;
  {$ENDIF}
  {$IFNDEF LCLLIB}
  frm.OnKeyDown := DoFormKeyDown;
  {$ENDIF}
  {$IFDEF LCLLIB}
  frm.OnKeyDown := @DoFormKeyDown;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  frm.Position := poScreenCenter;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  BuildEditor(frm);
  frm.ActiveControl := FGeneralPanel;
  {$ENDIF}
  TTMSFNCUtils.ScaleForCurrentDPI(frm);
  {$IFNDEF WEBLIB}
  Result := frm.ShowModal;
  if (Result <> mrOk) and Assigned(Chart) then
  begin
    Chart.Assign(nil);
    Chart.BeginUpdate;
    Chart.Assign(FCopyChart);
    Chart.EndUpdate;
    FCopyChart := nil;
  end;
  frm.Free;
  {$ELSE}
  frm.ShowModal(
  procedure(AResult: TModalResult)
  begin
    if (AResult <> mrOk) and Assigned(Chart) then
    begin
      Chart.Assign(nil);
      Chart.BeginUpdate;
      Chart.Assign(FCopyChart);
      Chart.EndUpdate;
      FCopyChart := nil;
    end;
    frm := nil;
    if Assigned(AProc) then
      AProc(AResult);
  end);
  {$ENDIF}
end;

function TTMSFNCChartTypeEditor.GetDocURL: string;
begin
  Result := TTMSFNCBaseDocURL + 'tmsfncchart';
end;

function TTMSFNCChartTypeEditor.GetInstance: NativeUInt;
begin
  Result := HInstance;
end;

function TTMSFNCChartTypeEditor.GetTipsURL: string;
begin
  Result := 'https://www.tmssoftware.com/site/tmsfncchart.asp?s=faq';
end;

procedure TTMSFNCChartTypeEditor.Initialize;
var
  I: Integer;
  same: Boolean;
begin
  same := FChart.Series.Count > 0;
//  GVH if all series types are same set selected type then
  for I := 0 to FChart.Series.Count - 1 do
  begin
    if FChart.Series[I].ChartType <> FChart.Series[0].ChartType then
    begin
      same := False;
      Break;
    end;
  end;

  if same then
  begin
    FChartSelectorLine.Selected := FChartSelectorLine.ChartType = FChart.Series[0].ChartType;
    FChartSelectorDigitalLine.Selected := FChartSelectorDigitalLine.ChartType = FChart.Series[0].ChartType;
    FChartSelectorXYLine.Selected := FChartSelectorXYLine.ChartType = FChart.Series[0].ChartType;
    FChartSelectorArea.Selected := FChartSelectorArea.ChartType = FChart.Series[0].ChartType;
    FChartSelectorStackedArea.Selected := FChartSelectorStackedArea.ChartType = FChart.Series[0].ChartType;
    FChartSelectorStackedPercArea.Selected := FChartSelectorStackedPercArea.ChartType = FChart.Series[0].ChartType;
    FChartSelectorBand.Selected := FChartSelectorBar.ChartType = FChart.Series[0].ChartType;
    FChartSelectorBar.Selected := FChartSelectorBar.ChartType = FChart.Series[0].ChartType;
    FChartSelectorStackedBar.Selected := FChartSelectorStackedBar.ChartType = FChart.Series[0].ChartType;
    FChartSelectorPercBar.Selected := FChartSelectorPercBar.ChartType = FChart.Series[0].ChartType;
    FChartSelectorOHLC.Selected := FChartSelectorOHLC.ChartType = FChart.Series[0].ChartType;
    FChartSelectorCandleStick.Selected := FChartSelectorCandleStick.ChartType = FChart.Series[0].ChartType;
    FChartSelectorBoxPlot.Selected := FChartSelectorBoxPlot.ChartType = FChart.Series[0].ChartType;
    FChartSelectorMarker.Selected := FChartSelectorMarker.ChartType = FChart.Series[0].ChartType;
    FChartSelectorXYMarker.Selected := FChartSelectorXYMarker.ChartType = FChart.Series[0].ChartType;
    FChartSelectorPie.Selected := FChartSelectorPie.ChartType = FChart.Series[0].ChartType;
    FChartSelectorSizedPie.Selected := FChartSelectorSizedPie.ChartType = FChart.Series[0].ChartType;
    FChartSelectorVarRadiusPie.Selected := FChartSelectorVarRadiusPie.ChartType = FChart.Series[0].ChartType;
    FChartSelectorSpider.Selected := FChartSelectorSpider.ChartType = FChart.Series[0].ChartType;
  end;
end;

function TTMSFNCChartTypeEditor.SaveChartMessage: Boolean;
var
  res: Integer;
begin
  {$IFNDEF WEBLIB}
  Result := False;
  res := TTMSFNCUtils.Message(sTMSFNCChartTypeEditorSaveChartMessage, TMsgDlgType.mtConfirmation, [TMsgDlgBtn.mbYes, TMsgDlgBtn.mbNo], 0);
  if res = VALUE_MBYES then
  {$ENDIF}
    Result := True;
end;

procedure TTMSFNCChartTypeEditor.SetAppearance;
var
  {$IFDEF VCLLIB}
  LDetails: TThemedElementDetails;
  clr: TTMSFNCGraphicsColor;
  {$ENDIF}
  okfntCol, fntCol, fillCol, primCol: TTMSFNCGraphicsColor;
  SubPanelFillCol, SubPanelStrokecol, MainPanelCol: TTMSFNCGraphicsColor;

//  procedure SetChartTypeSelector(ABtn: TTMSFNCEditorButton);
//  begin
//    ABtn.Appearance.TextAlignVertical := gtaLeading;
//    SetEditorIconButtonAppearance(ABtn,primCol,EDITORBUTTONROUNDING, fntCol, fillCol);
//    TTMSFNCUtils.SetFontSize(ABtn.Appearance.Font, 14);
//    TTMSFNCUtils.SetFontSize(ABtn.Appearance.HoverFont, 14);
//    TTMSFNCUtils.SetFontSize(ABtn.Appearance.DownFont, 14);
//    {$IFDEF VCLLIB}
//    if TTMSFNCChartOpen(FChart).VCLStylesEnabled then
//    begin
//      if (fc <> gcNull)then
//      begin
//        if Assigned(ABtn.Bitmap.SVG) then
//          ABtn.Bitmap.SVG.CustomFillColor := fc;
//        ABtn.Appearance.Font.Color := fc;
//      end;
//    end;
//    {$ENDIF}
//
//    ABtn.DownBitmap.Assign(ABtn.Bitmap);
//    {$IFNDEF WEBLIB}
//    if Assigned(ABtn.DownBitmap.SVG) then
//      ABtn.DownBitmap.SVG.CustomFillColor := ABtn.Appearance.SelectedFont.Color;
//    {$ENDIF}
//  end;
begin
  primCol := EDITORPRIMCOLOR;
  fillCol := EDITORAUTOCOLOR;
  fntCol := EDITORAUTOCOLOR;
  okfntCol := EDITOROKFONTCOLOR;
  SubPanelStrokeCol := EDITORAUTOCOLOR;
  SubPanelFillCol := EDITORAUTOCOLOR;
  MainPanelCol := EDITORAUTOCOLOR;

  {$IFDEF VCLLIB}
  if TTMSFNCChartOpen(FChart).VCLStylesEnabled then
  begin
    clr := StyleServices.GetStyleColor(scButtonHot);
    if clr <> clNone then
      primCol := clr;

    LDetails := StyleServices.GetElementDetails(ttbButtonPressed);
    if StyleServices.GetElementColor(LDetails, ecTextColor, clr) and (clr <> clNone) then
      okfntCol := clr;

//    LDetails := StyleServices.GetElementDetails(ttbButtonHot);
//    if StyleServices.GetElementColor(LDetails, ecTextColor, clr) and (clr <> clNone) then
//    begin
//      fc := clr;
////      okfntCol := clr;
//    end;

    LDetails := StyleServices.GetElementDetails(ttbButtonNormal);

    if StyleServices.GetElementColor(LDetails, ecFillColor, clr) and (clr <> clNone) then
      fillCol := clr;

    if StyleServices.GetElementColor(LDetails, ecTextColor, clr) and (clr <> clNone) then
      fntCol := clr;

    LDetails := StyleServices.GetElementDetails(tpPanelBackground);
    if StyleServices.GetElementColor(LDetails, ecFillColor, clr) and (clr <> clNone) then
      SubPanelFillCol := clr;
    if StyleServices.GetElementColor(LDetails, ecBorderColor, clr) and (clr <> clNone) then
      SubPanelStrokeCol := clr;

    clr := StyleServices.GetSystemColor(clBtnFace);
    if (clr <> clNone) then
    begin
      MainPanelCol := clr;
    end;
  end;
  FButtonOk.StyleElements := FButtonOk.StyleElements - [seClient];
  FButtonCancel.StyleElements := FButtonCancel.StyleElements - [seClient];
  FGeneralPanel.StyleElements := FGeneralPanel.StyleElements - [seClient];
  FPanel.StyleElements := FPanel.StyleElements - [seClient];
  {$ENDIF}

  SetEditorOKButtonAppearance(FButtonOk,primCol, EDITORBUTTONROUNDING, okfntCol);
  SetEditorCancelButtonAppearance(FButtonCancel, primCol, EDITORBUTTONROUNDING, fntCol, fillCol);

  SetEditorSubPanelAppearance(FGeneralPanel, SubPanelFillCol, SubPanelStrokeCol);
  SetEditorBackPanelAppearance(FPanel, MainPanelCol, MainPanelCol);
end;

procedure TTMSFNCChartTypeEditor.SetChart(const Value: TTMSFNCChart);
begin
  FChart := Value;
end;

{$IFDEF WEBLIB}

{ TTMSFNCChartTypeEditorForm }

constructor TTMSFNCChartTypeEditorForm.CreateDialogNew(AChartEditor: TTMSFNCChartTypeEditor; ACaption: string);
begin
  FChartEditor := AChartEditor;
  inherited CreateDialogNew(ACaption);
end;

procedure TTMSFNCChartTypeEditorForm.LoadDFMValues;
begin
  inherited LoadDFMValues;
  if Assigned(FChartEditor) then
  begin
    FChartEditor.BuildEditor(Self);
  end;
end;

procedure TTMSFNCChartTypeEditorForm.Loaded;
var
  css: string;
begin
  inherited;

  css := Application.IDECSS;

  if (css <> '') then
  begin
    AddCSS('IDECSS', css);
    ElementClassName := 'IDEBkg';
    CaptionElement['class'] := 'IDECaption IDEFont';
    if Assigned(FChartEditor) then
      FChartEditor.ApplyCSS(css);
  end;
end;
{$ENDIF}

{ TTMSFNCChartEditorSelector }

constructor TTMSFNCChartEditorSelector.Create(AOwner: TComponent);
begin
  inherited;

  SelectedColor := EDITORPRIMCOLOR;
  {$IFDEF FMXLIB}
  Font.Size := 12;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  Font.Size := 8;
  {$ENDIF}

  Width := SELECTORSIZE + 10;
  Height := SELECTORSIZE;
  {$IFDEF VCLLIB}
  InitVCLStyes;
  {$ENDIF}
end;

end.
